/**
 * Created by yqdong on 2018/3/18.
 * qq: 1013501639
 * @author yqdong
 *
 */
import { mutations, actions, apis, getters } from '../constants'
import Store from '../Store'
import { util } from '../../utils'

export default function (ajax) {
  let store = new Store({
    state: {
      userProps: [],
      sessionDays: null,
      recentEvents: [],
      sessions: []
    },
    mutations: {
      [mutations.userInfo.setRecentEvents] (state, events) {
        state.recentEvents = events
      },
      [mutations.userInfo.setUserProps] (state, props) {
        state.userProps = props
      },
      [mutations.userInfo.setSessionCounts] (state, data) {
        state.sessionDays = data
      },
      [mutations.userInfo.setSessions] (state, sessions) {
        state.sessions = sessions
      }
    },
    getters: {
    },
    actions: {
      [actions.userInfo.getInfo] (context, data) {
        if (data.showSimple) {
          store.setReady(context, 'recentEvents', false)
          context.commit(mutations.userInfo.setRecentEvents, [])
        } else {
          store.setReady(context, 'sessionDays', false)
          store.setReady(context, 'userProps', false)
          context.commit(mutations.userInfo.setUserProps, [])
          context.commit(mutations.userInfo.setSessionCounts, [])
        }
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.userInfo.getInfos,
            method: 'post',
            data,
            useTransform: false
          })
          .then(res => {
            if (data.showSimple) { // 最近30天的事件列表
              context.commit(mutations.userInfo.setRecentEvents, res.data.user.eventCounts)
              store.setReady(context, 'recentEvents', true)
            } else { // 用户属性以及最近30天的会话统计
              context.commit(mutations.userInfo.setUserProps, res.data.user.app_user)
              context.commit(mutations.userInfo.setSessionCounts, res.data.user.sessionDays)
              store.setReady(context, 'sessionDays', true)
              store.setReady(context, 'userProps', true)
            }
            resolve()
          })
          .catch(reject)
        })
      },
      [actions.userInfo.getSessions] (context, data) {
        store.setReady(context, 'sessions', false)
        context.commit(mutations.userInfo.setSessions, [])
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.userInfo.getSessions,
            method: 'post',
            data,
            useTransform: false
          })
          .then(res => {
            context.commit(mutations.userInfo.setSessions, (res && res.data) ? res.data.sessionInfos : [])
            store.setReady(context, 'sessions', true)
            resolve()
          })
          .catch(reject)
        })
      },
      [actions.userInfo.getEventInfo] (context, data) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.userInfo.getEventInfo,
            method: 'post',
            data,
            useTransform: false
          })
          .then(resolve)
          .catch(reject)
        })
      }
    }
  })
  return store
}
